export default __webpack_public_path__ + "static/media/postal-icon.7ea8e06e.png";